export const i18n = {
  ru: {
    brand: "Вареник 18+",
    tagline: "Запретный плод. Войти — на свой страх и риск.",
    subtagline: "Закрытая экосистема Telegram-каналов, чатов и приватов.",
    enterAt: "Тебе уже исполнилось 18? Тогда выбирай дверь.",
    footer: "© Вареник 18+ · Только для совершеннолетних · 18+ ONLY",
    disclaimer: "Контент 18+. Покидая эту страницу, ты подтверждаешь свой возраст.",
    vpnNotice: "Для пользователей из РФ — Telegram доступен только через VPN",
    cautionTape: "ВХОД ЗАПРЕЩЕН ✦ 18+ ONLY ✦ DO NOT CROSS ✦ ОСТОРОЖНО ✦ CAUTION ✦",
    adminTitle: "Админ панель",
    adminLogin: "Вход админа",
    password: "Пароль",
    enter: "Войти",
    addLink: "Добавить кнопку",
    editLink: "Редактировать",
    delete: "Удалить",
    moveUp: "Вверх",
    moveDown: "Вниз",
    labelRu: "Название (RU)",
    labelEn: "Название (EN)",
    url: "Ссылка",
    save: "Сохранить",
    cancel: "Отмена",
    logout: "Выйти",
    confirmDelete: "Точно удалить?",
    loginError: "Неверный пароль",
    loginSuccess: "Добро пожаловать",
    saved: "Сохранено",
    deleted: "Удалено",
    open: "Открыть",
    closePanel: "Закрыть панель",
    stats: "Статистика",
    totalVisits: "Всего визитов",
    totalClicks: "Всего кликов",
    last7days: "Визиты за 7 дней",
    perLink: "Клики по ссылкам",
    clicks: "кликов",
    tabLinks: "Блоки",
    tabEternal: "Вечные ссылки",
    tabStats: "Статистика",
    urlOptional: "Основная ссылка (необязательно)",
    contentRu: "Текст блока (RU)",
    contentEn: "Текст блока (EN)",
    articleHint: "Напиши текст и выдели слова для ссылок…",
    fillLinkFields: "Заполни названия и добавь ссылку или текст",
    articleOnly: "Статья без основной ссылки",
    openResource: "Открыть ресурс",
    emptyArticle: "Текст для этого блока пока не добавлен.",
    eternalName: "Название ссылки",
    eternalSlug: "Адрес (slug)",
    targetUrl: "Куда переадресовывать",
    fillEternalFields: "Заполни название и целевую ссылку",
    addEternal: "Создать вечную ссылку",
    active: "Активна",
    inactive: "Выключена",
    copied: "Скопировано",
  },
  en: {
    brand: "Varenik 18+",
    tagline: "Forbidden fruit. Enter at your own risk.",
    subtagline: "A closed ecosystem of Telegram channels, chats and privates.",
    enterAt: "Are you 18+ already? Then pick a door.",
    footer: "© Varenik 18+ · Adults only · 18+ ONLY",
    disclaimer: "Adult content. By leaving this page you confirm you are of legal age.",
    vpnNotice: "Russian users: Telegram only works via VPN",
    cautionTape: "DO NOT CROSS ✦ 18+ ONLY ✦ CAUTION ✦ KEEP OUT ✦ ВХОД ЗАПРЕЩЕН ✦",
    adminTitle: "Admin panel",
    adminLogin: "Admin login",
    password: "Password",
    enter: "Enter",
    addLink: "Add button",
    editLink: "Edit",
    delete: "Delete",
    moveUp: "Up",
    moveDown: "Down",
    labelRu: "Label (RU)",
    labelEn: "Label (EN)",
    url: "URL",
    save: "Save",
    cancel: "Cancel",
    logout: "Logout",
    confirmDelete: "Really delete?",
    loginError: "Wrong password",
    loginSuccess: "Welcome",
    saved: "Saved",
    deleted: "Deleted",
    open: "Open",
    closePanel: "Close panel",
    stats: "Stats",
    totalVisits: "Total visits",
    totalClicks: "Total clicks",
    last7days: "Visits · last 7 days",
    perLink: "Clicks per link",
    clicks: "clicks",
    tabLinks: "Blocks",
    tabEternal: "Eternal links",
    tabStats: "Stats",
    urlOptional: "Main URL (optional)",
    contentRu: "Block text (RU)",
    contentEn: "Block text (EN)",
    articleHint: "Write text and select words to add links…",
    fillLinkFields: "Fill in both titles and add a URL or article text",
    articleOnly: "Article without main URL",
    openResource: "Open resource",
    emptyArticle: "No article text has been added yet.",
    eternalName: "Link name",
    eternalSlug: "Slug",
    targetUrl: "Redirect target",
    fillEternalFields: "Fill in the name and target URL",
    addEternal: "Create eternal link",
    active: "Active",
    inactive: "Disabled",
    copied: "Copied",
  },
};

export const t = (lang, key) => (i18n[lang] && i18n[lang][key]) || i18n.ru[key] || key;
